<template>
  <div id="app">

    <!-- Navigation -->
    <nav v-if="loginStatus" class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div class="container">
        <a class="navbar-brand" href="#">WMK Trading GmbH</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li v-if="loginStatus" class="nav-item active">
              <logout-btn> </logout-btn>
            </li>
          </ul>
        </div>
      </div>
    </nav>


    <!-- Page Content -->
    <component v-bind:is="view"></component>


    <!-- Footer -->
    <footer class="py-3 bg-dark">
      <div class="container">
        <p class="m-0 text-center text-white">&copy; WMK Trading GmbH | <span style="cursor: pointer" @click="imprint">Impressum</span></p>
      </div>
    </footer>

    <!-- Impressum -->
    <div style="display: none">
      <div ref="imprint">
        <hr>
        <address>
          <div class="mb-3">
            WMK Trading GmbH<br>
            Waltrup 16<br>
            48341 Altenberge (Deutschland)<br>
            <b>Handelsregister: </b>Amtsgericht Münster HRB 15212<br>
            <b>USt-IdNr.: </b>DE 300422623<br>
          </div>
          <div>
            <b>Fon</b> +49 (0)2505/8029495<br>
            <b>Fax</b> +49 (0)2505/8029493<br>
            <b>E-Mail</b>  <a href="mailto:service@wmk-trading.de"> service@wmk-trading.de</a></div>
        </address>
        <p>Geschäftsführer: Herr Hatem Khodor</p>
      </div>
    </div>

  </div>
</template>

<script>

    import {store} from './store/store'
    import Login from './views/login'
    import LogoutBtn from './components/LogoutBtn'
    import Dashboard from './views/dashboard'
    import Contact from "./views/Contact";
    import info from 'ConsoleApp'

    export default {
    name: 'app',
    store: store,
    components: {
        Login,
        LogoutBtn,
        Dashboard,
        Contact
    },

    data() {
        return{
            dashboard: false,
            PACKAGE_JSON: JSON.parse(JSON.stringify(require('../package.json'))),
        }
    },

    computed: {

        view () {
            if(!this.$store.getters.getLoginStatus){
                return 'login'
            }

            if(this.$store.getters.getLoginStatus === 'withoutlogin'){
              return 'contact'
            }

            return 'dashboard'
        },

        loginStatus () {
            return this.$store.getters.getLoginStatus
        }
    },

    methods: {

      imprint () {

          this.$swal({
              title: 'Impressum',
              content: this.$refs.imprint,
              className: "shippingModal"
          })
      }
    },

    mounted () {
      info(this.PACKAGE_JSON.name, this.PACKAGE_JSON.version)
    },

    created() {

        // Check loginstatus and set data in store
        this.$RestClient.checkLoginStatus()
            .then((data) => {

                if(data.login){
                    this.$store.commit('setLoginStatus', true)
                    this.$store.commit('setUserData', data.user)
                }
            })
    }
}
</script>

<style src="./assets/local.css"></style>



